// removed by extract-text-webpack-plugin
module.exports = {"mtxl":"Home-mtxl-a2d21bb2","mtl":"Home-mtl-d195691f","mtm":"Home-mtm-7105e8ec","mts":"Home-mts-cb7e5a3e","mtxs":"Home-mtxs-99f04b1c","heading":"Home-heading-1fbabcea","p":"Home-p-39309432","intro":"Home-intro-2ef9d978","awards":"Home-awards-698f8a1e","promoContainer":"Home-promoContainer-10a1792b","billboard":"Home-billboard-89fbb07d","mpu":"Home-mpu-d1d1d8ed","headerAd":"Home-headerAd-cc7d3826","sideAd":"Home-sideAd-af062bac","classDetailCarouselItems":"Home-classDetailCarouselItems-1e4f9292"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/rootContainer/Home.scss
// module id = 813
// module chunks = 0